import crewsaveorcancelbuttons = require("./crewsaveorcancelbuttons");
import creweditdeletebuttons = require("./creweditdeletebuttons");
import crewpageleavelistener = require("./crewpageleavelistener");
import workgroupButtons = require("./workgroup.buttons");
import multiselect = require("./multiselect");
import crewpdfviewer = require("./crewpdfviewer");
import crewpdfviewersinglepage = require("./crewpdfviewersinglepage");
import crewreportmenubar = require("./crewreportmenubar");
import wizardButtons = require("./wizard.buttons");
import crewInputDatePosInf = require("./crewinputdateposinf");
import crewInputDateNegInf = require("./crewinputdateneginf");
import uiCore = require("../core/uicore");

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import { HierarchicalMultiSelectComponent } from "./hierarchical-multiselect.component";
import { CoreModule } from "../core/core.module";
import { CrewWizard } from "./crew-wizard.component";
import { CrewWizardTab } from "./crew-wizard-tab.component";
import { PersonAndWorkGroupSelect } from "./person-and-work-group-select.component";
import { MultiselectButtonsComponent } from "./multiselect-buttons.component";

export class ComponentsInstaller extends uiCore.BaseInstaller {

    constructor() {

        var pages = [];
        var controls = [
            crewsaveorcancelbuttons.SaveOrCancelButtonsDirective,
            creweditdeletebuttons.EditDeleteButtonsDirective,
            workgroupButtons.WorkGroupButtons,
            crewpageleavelistener.PageLeaveListener,
            multiselect.MultiSelectDirective,
            crewpdfviewer.PdfReportViewerDirective,
            crewpdfviewersinglepage.PdfReportViewerSinglePageDirective,
            crewreportmenubar.ReportMenuBarDirective,
            wizardButtons.WizardButtonsDirective,
            crewInputDatePosInf.InputDatePosInfDirective,
            crewInputDateNegInf.InputDateNegInfDirective
        ];
        var installers = [];

        super(pages, controls, installers);
    }
}

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        CoreModule,
        AllMaterialModule,
        FlexLayoutModule
    ],
    declarations: [
        wizardButtons.WizardButtonsComponent,
        HierarchicalMultiSelectComponent,
        workgroupButtons.WorkgroupButtonsComponent,
        multiselect.MultiselectComponent,
        MultiselectButtonsComponent,
        PersonAndWorkGroupSelect,
        CrewWizard,
        CrewWizardTab
    ],
    exports: [
        wizardButtons.WizardButtonsComponent,
        HierarchicalMultiSelectComponent,
        workgroupButtons.WorkgroupButtonsComponent,
        multiselect.MultiselectComponent,
        MultiselectButtonsComponent,
        PersonAndWorkGroupSelect,
        CrewWizard,
        CrewWizardTab
    ]
})
export class ComponentsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/components.installer.ts